import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlatformIntegrationComponent } from '@brand-lolly/app/authentication-v2/modules/onboarding/components/integration/platform-integration.component';
import { BillingPageComponent } from '@brand-lolly/app/billing/billing-page/billing-page.component';
import { CreditsPageComponent } from '@brand-lolly/app/billing/credits-page/credits-page.component';
import { ManageSubscriptionPlanComponent } from '@brand-lolly/app/billing/manage-plan/components/manage-subscription-plan/manage-subscription-plan.component';
import { billingOwnerGuard } from '@brand-lolly/app/shared/guards/billing-owner.guard';
import { AssistantKnowledgePageComponent } from './components/assistant-knowledge/assistant-knowledge-page.component';
import { IntegrationsComponent } from './components/integrations/integrations.component';
import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { SettingsConComponent } from './components/settings-con/settings-con.component';
import { TeamPageComponent } from '@brand-lolly/app/user-management/team/team-page/team-page.component';

const routes: Routes = [
	{
		path: '',
		component: SettingsConComponent,
		children: [
			{
				path: 'teams',
				component: TeamPageComponent
			},
			{
				path: 'integrations',
				component: IntegrationsComponent
			},
			{
				path: 'assistant-knowledge',
				component: AssistantKnowledgePageComponent
			},
			{
				path: 'integrations/integration/:platform',
				component: PlatformIntegrationComponent,
				data: {
					finalRedirectUrl: '/user-management/integrations'
				}
			},
			{
				path: 'my-profile',
				component: MyProfileComponent
			},
			{
				// Invoices, the payment method and cancellation — the account's
				// payment relationship, which belongs to the person who holds
				// it. A member typing this address lands on their own credit
				// statement instead.
				path: 'billing',
				canActivate: [billingOwnerGuard],
				component: BillingPageComponent
			},
			{
				// NOT guarded, deliberately: a member's own balance and their
				// own spending are theirs to see. What the page must not offer
				// them is the purchase controls, which is done in the page
				// itself — a guard here would hide the half that IS theirs.
				path: 'credits',
				component: CreditsPageComponent
			},
			{
				path: 'current-plan',
				redirectTo: 'billing',
				pathMatch: 'full'
			},
			{
				path: 'manage-plan',
				canActivate: [billingOwnerGuard],
				component: ManageSubscriptionPlanComponent
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class UserSprintRoutingModule {}
